(function () {
	'use strict';

	MxSchemaPickerCtrl.$inject = ['mx.SolutionBuilderAgent.SchemaService', '$scope', '$attrs', '$q'];

	function MxSchemaPickerCtrl(schemaService, $scope, $attrs, $q) {
		var vm = this;
		var _filter, _selectedObjectsExpected;
		var servicePromise;

		vm.$onInit = function () {
			vm.group = null;
			_filter = vm.filter;

			vm.itemsFilter =
				vm.itemsFilter ||
				function (items) {
					return items;
				};

			_selectedObjectsExpected = $attrs.selectedObjects && $attrs.selectedObjects.length > 0;

			if (_selectedObjectsExpected || ($attrs.selectedObject && $attrs.selectedObject.length > 0)) {
				$scope.$watch('vm.model', function () {
					setSelectedSchemaItems();
				});
			}

			Object.defineProperty(vm, 'filter', {
				get: function () {
					return _filter;
				},
				set: function (value) {
					_filter = value;

					reloadItems();
				},
			});

			servicePromise =
				(vm.mxServiceContext && vm.mxServiceContext.$servicePromise) ||
				$q.when({
					isService: false,
				});
		};

		function setSelectedSchemaItems() {
			if (vm.model) {
				var selectedItems = Array.isArray(vm.model)
					? vm.model
					: vm.model.split(',').map(function (item) {
							return (item || '').trim();
					  });

				var getItems = vm.type === 'type' ? schemaService.getTypes() : schemaService.getClasses();

				getItems.then(function (items) {
					var objects = $.extend(
						true,
						[],
						items.filter(function (item) {
							return selectedItems.indexOf(vm.valueIsId ? item.Id : item.InternalName) > -1;
						})
					);

					if (_selectedObjectsExpected) {
						vm.selectedObjects = objects;
					} else {
						vm.selectedObject = objects.length > 0 ? objects[0] : null;
					}
				});
			} else if (_selectedObjectsExpected) {
				vm.selectedObjects = [];
			} else {
				vm.selectedObject = null;
			}
		}

		async function reloadItems() {
			const items = await vm.loadItems();
			$scope.$evalAsync(() => {
				vm.items = items;
			});
		}

		async function loadCIs() {
			return schemaService.getTypeItems(vm.valueIsId, vm.filter);
		}

		async function loadDDs() {
			const service = await servicePromise;
			let items = await schemaService.getClassItems(vm.valueIsId, vm.filter, vm.classType || -1);
			if (service.isService && (!vm.classType || vm.classType === -1 /*no filter*/ || vm.classType === 4) /*pickup*/) {
				items = items.concat(service.EnumTypes);
			}
			return items;
		}

		async function loadSchemaData() {
			let loadPromise = (vm.type === 'type' ? loadCIs() : loadDDs()).then((items) => (loadPromise !== vm.lastLoadPromise ? vm.lastLoadPromise : items));

			vm.lastLoadPromise = loadPromise;
			return loadPromise;
		}

		vm.loadItems = async function () {
			let items = await loadSchemaData();
			items = vm.itemsFilter(items);
			return items;
		};
	}

	var commonObjectPickerProperties = {
		type: '@',
		required: '=?require',
		ngRequired: '=?',
		filter: '=?',
		itemsFilter: '=?',
		classType: '=?',
		valueIsId: '=',
	};

	var commonObjectPickerTemplate =
		'data-name="{{vm.name}}" ' +
		'data-label="{{vm.label}}" ' +
		'data-hint="{{vm.hint}}" ' +
		'ng-model="vm.model" ' +
		'data-load-items="vm.loadItems" ' +
		'data-item-title-field="DisplayName" ' +
		'data-item-id-field="Name" ' +
		'ng-required="(vm.required || vm.ngRequired) && !vm.disabled && !vm.readOnly" ' +
		'data-disabled="vm.disabled" ' +
		'read-only="vm.readOnly" ' +
		'custom-validation="vm.customValidation" ';

	angular.module('mx.SolutionBuilderAgent').directive('mxSchemaPicker', function mxSchemaPickerDirective() {
		var directive = new mx.components.FormControlBase(MxSchemaPickerCtrl, null);

		directive.template = '<mx-picker ' + commonObjectPickerTemplate + '></mx-picker>';

		angular.extend(directive.bindToController, commonObjectPickerProperties);
		directive.bindToController.selectedObject = '=';
		directive.require.mxServiceContext = '?^mxServiceContext';

		delete directive.link;

		return directive;
	});

	angular.module('mx.SolutionBuilderAgent').directive('mxMultiSchemaPicker', function mxMultiSchemaPickerDirective() {
		var directive = new mx.components.FormControlBase(MxSchemaPickerCtrl, null);

		directive.template = '<mx-multi-picker ' + commonObjectPickerTemplate + ' data-separator-char="," ' + ' data-load-on-typing="false" ' + '></mx-multi-picker>';

		angular.extend(directive.bindToController, commonObjectPickerProperties);
		directive.bindToController.selectedObjects = '=?';
		directive.require.mxServiceContext = '?^mxServiceContext';

		delete directive.link;

		return directive;
	});
})();
